import React from "react";
import "./Image.scss";

const Image = React.memo(({src, alt = ""}) => {
  return (
    <div className="Image">
      <img src={src} alt={alt} />
    </div>
  );
});

export default Image;
